/**
 * @author Sarthak Sharma.
 * @since 06-01-2024.
 * @type {string} Role Type action types.
 */

export const SET_LOADING = '[ROLE_TYPE] SET_LOADING';
export const SET_ROLE_TYPE_LIST = '[ROLE_TYPE] SET_ROLE_TYPE_LIST';

